<template>
  <section class="hero">
    <!-- Background Video -->
    <video
      class="video-bg"
      autoplay
      muted
      loop
      playsinline
    >
      <source src="@/assets/images/sushi-shogun-video.mp4" type="video/mp4" />
    </video>

    <!-- Optional overlay -->
    <div class="overlay"></div>

    <!-- Content -->
    <div class="parallax-text"></div>
  </section>
</template>

<script>
export default {};
</script>

<style scoped>
.hero {
  position: relative;
  width: 100%;
  height: 120vh;
  overflow: hidden;
  margin-top: -200px;
}

/* Video Background */
.video-bg {
  position: absolute;
  top: 0;
  left: 0;

  width: 100%;
  height: 100%;

  object-fit: cover;

  z-index: 1;
}

/* Optional dark overlay */
.overlay {
  position: absolute;
  inset: 0;
  background: rgba(0, 0, 0, 0.3);
  z-index: 2;
}

/* Foreground content */
.parallax-text {
  position: relative;
  z-index: 3;

  height: 200px;
  background-image: url("~@/assets/images/Vector.png");
  background-repeat: no-repeat;
  background-position: center;

  margin-top: calc(120vh - 70px);
}

@media only screen and (max-width: 639px) {
  .hero {
    height: 100vh;
    margin-top: 0;
  }
}
</style>